import React from "react";
import { LineStyle } from "../interfaces/element";
import { LineGL } from "../LineGL";
import { DashLineGL } from "../DashLineGL/index";
export const ErrorBar = (props) => {
    return props.style === LineStyle.solid ? (React.createElement(LineGL, Object.assign({}, props))) : (React.createElement(DashLineGL, Object.assign({}, props)));
};
//# sourceMappingURL=ErrorBar.js.map